// src/components/Product.js
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../App.css';

const productData = {
  1: { 
    name: "Anessa Perfect Uv Sunscreen Skincare Milk Na Spf 50+ Pa++++ 60Ml",
    price: "฿944",
    originalPrice: "฿1000",
    image: "https://down-th.img.susercontent.com/file/th-11134201-7r992-m04qtcehfxkq34.webp",
    description: " อเนสซ่าเพอร์เฟค ยูวี ซันสกรีน สกินแคร์ มิลค์ เอ็นเอ เอสพีเอฟ 50+ พีเอ++++กันแดดเนื้อน้ำนม บางเบา ซึมซาบเร็ว สำหรับผิวหน้า ปกป้องผิวจากรังสี UV พร้อมลดเลือนจุดด่างดำ ฝ้าแดด เผยผิวสวย ฉ่ำโกล์ว ชุ่มชื้นยาวนาน 8 ชั่วโมง",
  },
  2: { 
    name: "Mizumi ครีมกันแดด Mizumi มิซึมิ ยูวี วอเตอร์ เซรั่ม สีฟ้า เอสพีเอฟ 50 พีเอ 40 กรัม",
    price: "฿399",
    originalPrice: "฿890",
    image: "https://medias.watsons.co.th/publishing/WTCTH-262540-front-U5AdcOS3-zoom.png?version=1730746217",
    description: "Mizumi UV Water Serum SPF50+/PA++++ 40g สนุกกับแสงแดดได้ทุกวัน กับ มิซูมิ เซรั่มกันแดด ครีมกันแดดสูตรน้ำ ที่ปราศจากสารกันแดดแบบเคมี จากมิซึมิ เนื้อสัมผัสบางเบา ไม่เหนียวเหนอะหนะ แต่ปกป้องสูงสุดจาก UVA1, UVA2 และ UVB พร้อมลดการอุดตันของผิว ครีมกันแดดสูตรน้ำ ที่ปราศจากสารกันแดดแบบเคมี 100 ช่วยปกป้องผิวจากรังสี UVA1, UVA2 และ UVB ด้วย SPF50+/PA++++ พร้อมลดโอกาศผิวถูกทำร้ายจากอนุมูลอิสระ ด้วยสาร Anti-Oxidant -SPF50+ PA++++ ปกป้องผิวจากรังสี UVA1/UVA2/UVB ต้นเหตุของความหมองคล้ำและริ้วรอยก่อนวัย -ลดโอกาศผิวถูกทำร้ายจากอนุมูลอิสระ ด้วยสาร Anti-Oxidant ประกอบไปด้วย Yuki Extract -Vitamin E ที่มีความเสถียรสูง เนื้อสัมผัลโดดเด่น เบาสบายผิว ไม่เหนียวเหนอะหนะ ไม่ทำให้หน้ามันเพิ่ม -เนื้อสัมผัสบางเบาแบบเซรั่ม คุมมัน ลดการอุดตันผิว - สำหรับใช้ทุกวันเป็นประจำ - ปราศจากน้ำมัน น้ำหอม พาราเบน แอลกอฮอล์ และสีสังเคราะห์",
  },
  3: { 
    name: "Acne Aid แอคเน่ เอด ลิควิด คลีนเซอร์ 100มล",
    price: "฿169",
    originalPrice: "฿225",
    image: "https://medias.watsons.co.th/publishing/WTCTH-295997-front-zoom.jpg?version=1716879767",
    description: "Acne Aid แอคเน่-เอด ลิควิด คลีนเซอร์ สำหรับผิวมัน แอคเน่-เอด ลิควิด เคลนเซอร์ ผลิตภัณฑ์ทำความสะอาดผิวหน้าและผิวกาย สำหรับผิวมัน เป็นสิวง่าย สามารถใช้กับยารักษาสิวได้อย่างมีประสิทธิภาพ ยอดขายอันดับ1ในร้านยาและโรงพยาบาล แอคเน่-เอด ช่วยลดความมันส่วนเกินได้อย่างอ่อนโยนโดยไม่ทำร้ายผิว ช่วยทำความสะอาดผิวหน้าและรูขุมขนได้อย่างสะอาดล้ำลึกด้วยสูตรเฉพาะ ปราศจากสบู่พร้อมผสานมอยซ์เจอร์ไรเซอร์ช่วยบำรุงผิวให้มีสุขภาพดีและมีค่า pH ที่สมดุลอ่อนโยน ไม่ทำให้ผิวแห้งตึง สามารถใช้ได้ทุกวันเพื่อผิวสุขภาพดี ข้อมูลอ้างอิงจาก IQVIA (ประเทศไทย) ต.ค. 2016 - ก.ย. 2017",
    discountCode: "SALE10",
    discountPercent: 10,
  },
  4: { 
    name: "In2It อินทูอิท พลัมพิ่ง ลิป ออย 4ก. #03",
    price: "฿199",
    originalPrice: "",
    image: "https://medias.watsons.co.th/publishing/WTCTH-309206-front-9eHH7sEX-zoom.png?version=1730745188",
    description: "ลิปออยล์เนื้อบางเบา มอบความฉ่ำ แวววาวมากเป็นพิเศษ ให้ความรู้สึกเบา สบายริมฝีปาก และไม่เหนียวเหนอะหนะเวลาทา เนื้อออยมีสีโปร่งใสบาง ๆ ช่วยทำริมฝีปากแลดูมีสุขภาพดี อีกทั้งยังอุดมด้วยส่วนผสมของสารบำรุงเพื่อความนุ่ม ชุ่มชื้น และทำให้ริมฝีปากอวบอิ่ม น่าสัมผัสมากยิ่งขึ้นด้วย 3 คุณสมบัติพิเศษที่ผสานอยู่ใน ลิป ออย เพิ่มความชุ่มชื้นให้กับริมฝีปากได้ยาวนานยิ่งขึ้น เพิ่มความอวบอิ่ม ริมฝีปากดูเปล่งปลั่ง และเพิ่มความกระชับให้ริมฝีปาก เพิ่มความเรียบเนียน ลดร่องปาก และ ริ้วรอย ริมฝีปากแน่นดูเต่งตึง สารบำรุง Marine Collagen Spheres นวัตกรรมเติมเต็มริ้วรอยในรูปแบบใหม่ที่ผสมผสานคุณประโยชน์ของสารสกัด Marine Collagen ซึ่งเป็น collagen จากปลาดาว และ Glycosaminoglycans ซึ่งเป็นสารที่มีอยู่ในโครงสร้างของผิว ถูกทำให้ยู่ในรูปแบบ Sphere และจะค่อยๆ ปลดปล่อยความชุ่มชื้นเข้าสู่ผิว Super Moisture Complex ผสมผสานกันอย่างลงตัว จาก วิตามินอี กรดไฮยาลูโรนิก และน้ำมันออร์แกนิกธรรมชาติ น้ำมันมะพร้าว โจโจ้บาออยล์ และอาร์แกนออยล์ เพื่อเติมเต็มความชุ่มชื้นให้ผิวได้อย่างสูงสุด ให้ริมฝีปากดูสวยอวบอิ่มตั้งแต่ครั้งแรกที่ใช้ พร้อมมอบความชุ่มชื้นให้กับริมฝีปากได้ยาวนานมากยิ่งขึ้น",
  },
  5: { 
    name: "Senka เซนกะ เพอร์เฟ็ค วิป 120 กรัม (วิปโฟม)",
    price: "฿184",
    originalPrice: "฿199",
    image: "https://medias.watsons.co.th/publishing/WTCTH-263862-front-U3oUWyzl-zoom.png?version=1730746225",
    description: "วิปโฟมล้างหน้า เซนกะ เพอร์เฟ็ค วิป (Perfect Whip) ฟองโฟมเนื้อละเอียดยิ่งขึ้น ทำความสะอาดผิวหน้าล้ำลึก พร้อมมอบความสดชื่น สบายผิวภายหลังการล้างหน้า คงความนุ่ม ชุ่มชื่นให้ผิว ไม่ทำให้ผิวแห้งตึง ด้วยส่วนผสมจากรังไหมสีขาว ซึ่งมอบผิวสะอาด เนียนนุ่ม ชุ่มชื่นปกป้องผิวจากการทำร้ายภายนอก และ ดับเบิ้ล ไฮยารูรอนิค แอซิด คอมพาวด์ ที่ช่วยมอบความชุ่มชื่นไปอีกขั้นให้กับผิวหน้า Senka Perfect Whip มีด้วยกันทั้งหมด 4 สูตร คือ - SENKA Perfect Whip (สีฟ้า) สูตรออริจินอล - SENKA Perfect White Clay (สีขาว) สูตรผสมโคลนขาว - SENKA Perfect Whip Collagen In (สีชมพู) สูตรผสมคอลลาเจน - SENKA Perfect Whip Acne Care (สีเขียว) สูตรสำหรับคนเป็นสิวสามารถซื้อ Senka Perfect Whip ราคาสุดคุ้มพร้อมโปรโมชั่นได้ที่นี่",
  },
  6: { 
    name: "ครีมกันแดด Mizumi มิซึมิ ยูวี วอเตอร์ ดีเฟนส์ โปร 40 กรัม",
    price: "฿890",
    originalPrice: "฿1000",
    image: "https://medias.watsons.co.th/publishing/WTCTH-293471-front-zoom.jpg?version=1716868584",
    description: " อเนสซ่าเพอร์เฟค ยูวี ซันสกรีน สกินแคร์ มิลค์ เอ็นเอ เอสพีเอฟ 50+ พีเอ++++กันแดดเนื้อน้ำนม บางเบา ซึมซาบเร็ว สำหรับผิวหน้า ปกป้องผิวจากรังสี UV พร้อมลดเลือนจุดด่างดำ ฝ้าแดด เผยผิวสวย ฉ่ำโกล์ว ชุ่มชื้นยาวนาน 8 ชั่วโมง",
  },
  7: { 
    name: "Anessa Perfect Uv Sunscreen Skincare Milk Na Spf 50+ Pa++++ 60Ml",
    price: "฿420 ",
    originalPrice: "฿840",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/2/15/8d2b3f5d-b927-4d8b-9965-9e4a05585281_large.jpg",
    description: "สกินทิฟิค ไนอาซินาไมด์ ไบร์ทเทนนิ่ง มอยส์เจอร์ เจลเนื้อบางเบา ซึมซาบเร็ว และช่วยควบคุมความมัน ผสานด้วย Novel MSH Niacinamide เอกสิทธิ์เฉพาะของ SKINTIFIC ประกอบด้วยส่วนผสมที่ช่วยให้ความกระจ่างใสที่ประสิทธิภาพมากที่สุด 2 ชนิด ได้แก่ Alpha Arbutin และ Tranexamic Acid ซึ่งสามารถเพิ่มความกระจ่างใสได้เป็นอย่างดี MSH Niacinamide ได้รับการพิสูจน์ทางคลินิกแล้วว่ามีประสิทธิภาพมากกว่าไนอาซินาไมด์ทั่วไปถึง 10 เท่าเพื่อช่วยลดเลือนจุดด่างดำและรอยดำ อุดมด้วย Centella Asiatica และ 5X Ceramide ทำให้ผิวรู้สึกสงบในขณะที่ยังคงความแข็งแรงของเกราะป้องกันผิว ผลลัพธ์อาจแตกต่างกันไปในแต่ละบุคคล",
  },
  8: { 
    name: "บู๊ทส์ วิตามิน ซี ไบรท์เทนนิ่ง มอยส์เจอร์ไรซิ่ง ครีม เอสพีเอฟ30 พีเอ+++ 50มล.",
    price: "฿209",
    originalPrice: "฿309",
    image: "https://thmappbkk.blob.core.windows.net/boots/2023/7/25/fd545bfc-697e-4005-a1c1-fa02a9158f20_large.jpg",
    description: "บู๊ทส์ วิตามิน ซี ไบรท์เทนนิ่ง มอยส์เจอร์ไรซิ่ง ครีม เอสพีเอฟ30+ พีเอ+++ บำรุงพร้อมปกป้องผิวจากรังสี UVA/B ฝ้าแดด จุดด่างดำดูลดเลือน ผิวดูกระจ่างใส โกลว์ใน 3 วัน ผลิตภัณฑ์บำรุงผิวหน้าและลำคอ สูตรวีแกน ซึมซาบเร็ว ผสานสารป้องกันรังสี UVA/B SPF30 PA+++ช่วยปกป้องผิวจากแสงแดด พร้อมฟื้นบำรุงผิวคล้ำเสียและลดเลือนฝ้าแดด จุดด่างดำด้วย 2X vitamin C** และสารสกัดจากส้ม YUZU ให้ผิวดูกระจ่างใส โกลว์ใน 3 วัน*",
  },
  9: { 
    name: "Skintific สคินทิฟฟิค โคฟเวอร์ ออล์ เพอร์เฟกต์ คุชชั่น 04ดับเบิ้ลยู วอร์ม เบจ",
    price: "฿449",
    originalPrice: "$580",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/9/19/9294896e-c77f-4b85-a508-0658ab6544b8_large.jpg",
    description: "อเนสซ่าเพอร์เฟค ยูวี ซันสกรีน สกินแคร์ มิลค์ เอ็นเอ เอสพีเอฟ 50+ พีเอ++++กันแดดเนื้อน้ำนม บางเบา ซึมซาบเร็ว สำหรับผิวหน้า ปกป้องผิวจากรังสี UV พร้อมลดเลือนจุดด่างดำ ฝ้าแดด เผยผิวสวย ฉ่ำโกล์ว ชุ่มชื้นยาวนาน 8 ชั่วโมง",
  },
  10: { 
    name: "เบบี้ไบร์ท ฟลอร่ามอยส์ทูแมทท์ลิป 3G #10 เรดทิวลิป Rated stars out of 5",
    price: "฿295",
    originalPrice: "",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/10/4/428ec5b3-6fa6-4618-b628-524560a587f8_large.jpg",
    description: "ร่วมสนุกไปกับลิปเนื้อสัมผัสใหม่จาก Baby Bright Flora Moist to Matte Lip ลิปเนื้อมอยส์และแมทท์ในแท่งเดียว ให้สัมผัสแรกฉ่ำวาว เมื่อเบลนด์แล้วจะได้ฟินิชลุคเป็นลิปแมทท์เนื้อกำมะหยี่ เนียนนุ่มดุจใยไหม เกลี่ยง่าย ไม่หนักปาก สีชัด ติดทน เสริมคุณค่าสูตรวีแกน 100% อุดมไปด้วยสารสกัดจากใบไฮเดรนเยีย (Hydrangea Macrophylla Leaf Extract), น้ำมันเมล็ดองุ่น (Vitis Vinifera (Grape) Seed Oil), สารสกัดจากดอกคาเมเลีย (Camellia Oleifera Seed Oil) และวิตามินอี (Vitamin E) มีสารแอนตี้ออกซิแดนท์ ช่วยปกป้องริมฝีปากจากมลภาวะ ลดเลือนริ้วรอยร่องปาก พร้อมกักเก็บความชุ่มชื้นและความยืดหยุ่นให้ริมฝีปากดูเรียบเนียน อ่อนนุ่ม สุขภาพดี มีเสน่ห์อย่างน่าหลงใหล ปราศจากแอลกอฮอล์และพาราเบน",
  },
  11: { 
    name: "นีเวีย ลูมินัส630 แอนตี้สปอต แอดวานซ์ สปอต เซรั่ม 30 มล",
    price: "฿599",
    originalPrice: "฿799",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/10/4/c9117dae-11d9-4051-9184-2cabd5b99899_large.jpg",
    description: "นีเวีย ลูมินัส630 แอนตี้สปอต แอดวานซ์ สปอต เซรั่ม เซรั่มลดเลือนฝ้าแดด จุดด่างดำ อันดับ 1 ของนีเวีย จัดการฝ้าแดด จุดด่างดำได้ลึกถึงต้นตอ* และยังลดโอกาสการเกิดซ้ำ เห็นผลใน 2 สัปดาห์ เนื้อเซรั่มสัมผัสบางเบา ซึมเข้าบำรุงผิวอย่างรวดเร็ว อันดับ 1ของสินค้าประเภทเซรั่มลดเลือนจุดด่างดำของนีเวีย *ผิวชั้นอีพิเดอร์มิส ทดสอบในอาสาสมัคร 43 คน โดย Eurofins Dermscan Aix-En-Provence, ก.พ. - มี.ค. 2565 เครื่องสำอางไม่สามารถเปลี่ยนแปลงสีผิวตามธรรมชาติของแต่ละบุคคลได้ เมื่อใช้เป็นประจำอย่างต่อเนื่อง ผลลัพธ์ที่ได้ขึ้นอยู่กับสภาพผิวของแต่ละบุคคล",
  },
  12: { 
    name: "สกินทิฟิค ซิมไวท์ 377 ดาร์ก สปอต เซรั่ม เซรั่มลดเลือนจุดด่างดำ 50มล.",
    price: "฿694",
    originalPrice: "฿840",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/5/29/7bbc35a7-cc0e-4731-a3fb-3e6614c49187_large.jpg",
    description: "สกินทิฟิค เซรั่ม SymWhite377 ที่อุดมด้วยเนื้อบางเบาและน้ำหนักโมเลกุลต่ำ ซึมซาบสู่ผิวได้ง่ายและปรับจุดด่างดำบนผิวให้กระจ่างใส เนื้อบางเบา เพิ่มความกระจ่างใสและจัดการรอยดำได้อย่างมีประสิทธิภาพ",
  },
  13: { 
    name: "การ์นิเย่ สกิน แนทเชอรัลส์ ไบรท์ คอมพลีท โอเวอร์ไนท์ บูสเตอร์ เซรั่ม 30มล.",
    price: "฿499",
    originalPrice: "",
    image: "https://thmappbkk.blob.core.windows.net/boots/2023/7/20/47328791-5f9b-40d6-a8dd-f10692036768_large.jpg",
    description: "การ์นิเย่ สกิน แนทเชอรัลส์ ไบรท์ คอมพลีท โอเวอร์ ไนท์ บูสเตอร์ เซรั่ม สูตรกลางคืน ครั้งแรก กับ 10% วิตามินซีบริสุทธิ์ที่มีความเข้มข้นสูงสุด และทรงประสิทธิภาพสำหรับเวลากลางคืน ให้คุณตื่นมาพร้อมกับผิวดูกระจ่างใส นุ่มชุ่มชื้น เด้งฟู เนื้อเซรั่มตรงเข้าบำรุงผิวอย่างล้ำลึก รู้สึกสบายผิว บางเบา ซึมไว ไม่เหนอะหนะ เมื่อใช้เป็นประจำอย่างต่อเนื่อง - ผิวดูกระจ่างใสขึ้นใน 3 วัน - จุดด่างดำดูจางลง - ริ้วรอยดูลดเลือน - รู้สึกผิวเฟิร์ม กระชับขึ้นใน 7 วัน - ไม่มีส่วนผสมของพาราเบน ผ่านการทดสอบโดยผู้เชี่ยวชาญด้านผิวหนัง เหมาะกับผิวบอบบางมีแนวโน้มระคายเคืองง่าย สีของวิตามินซีบริสุทธิ์อาจมีการเปลี่ยนแปลง แต่ไม่มีผลต่อการใช้งานและประสิทธิภาพของผลิตภัณฑ์ ของการ์นิเย่ ผิวชั้นนอก ผลการทดสอบความพึงพอใจในอาสาสมัครจำนวน 79 ราย โดยสถาบันวิจัยลอรีอัล ประเทศฝรั่งเศส เมื่อ กันยายน 2022 ผลิตภัณฑ์ไม่สามารถเปลี่ยนแปลงโครงสร้างและสีผิวตามธรรมชาติของร่างกายได้ ผลลัพธ์ที่ได้ขึ้นอยู่กับสภาพผิวของแต่ละบุคคล",
  },
  14: { 
    name: "Revlon เรฟลอน คัลเลอร์สเตย์ เอ็กซ์เทนชั่นแนร์ เลงเทนนิ่ง มาสคาร่า แบล็ค",
    price: "฿944",
    originalPrice: "฿1000",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/10/10/41648875-4802-4d0e-9fd9-0d3f60eec9ac_large.jpg",
    description: "เรฟลอน คัลเลอร์สเตย์ เอ็กซ์เทนชั่นแนร์ เลงเทนนิ่ง มาสคาร่า ช่วยให้ขนตาดูยาวขึ้น 2 เท่า* มีส่วนผสมของ โปรวิตามิน B5 ช่วยบำรุงขนตาให้เงางาม ช่วยให้ขนตาดูหนา ยาว และแข็งแรง ความยาวเสมือนขนตาปลอม ติดทนเป็นพิเศษ ติดทนนานถึง 24 ชั่วโมงด้วยเทคโนโลยี Adapti Flex ขนแปรงเรียวเล็ก ช่วยให้ขนตาเรียงเส้นสวย เพิ่มความหนาให้ขนตาตลอดทั้งวัน ไม่เลอะ ไม่เป็นขุย เรฟลอน คัลเลอร์สเตย์ เอ็กซ์เทนชั่นแนร์ เลงเทนนิ่ง มาสคาร่า วิธีใช้ ดัดขนตาให้โค้งงอน วางแปรงมาสคาร่าชิดโคนขนตาและขยับแปรงเพื่อเพิ่มความหนาให้ขนตา จากนั้นปัดขึ้นไปตามความยาวของขนตา สามารถเพิ่มความหนาได้ตามต้องการ",
  },
  15: { 
    name: "บราวอิท อายดอลเอชดีอินเนอร์อายไลน์เนอร์ 0.1G #บราวน์",
    price: "฿259",
    originalPrice: "",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/10/4/5ada88f3-4e8c-4047-bf1f-5b6be644bb5d_large.jpg",
    description: "อายไลน์เนอร์เนื้อเจลแบบแท่งหมุนออโต้ เขียนเส้นคมชัดระดับ HD เนื้อนุ่ม เขียนง่ายไม่มีสะดุด ด้วยหัวดินสอขนาดเรียวเล็กเพียง 2 มม. เม็ดสีแน่นและแนบเนียนบนขอบตา สร้างมิติให้ดวงตากลมโตสไตล์ไอดอล กันน้ำ กันเหงื่อ ติดทนนาน สีไม่ดรอประหว่างวัน",
  },
  16: { 
    name: "นัมเบอร์เซเว่น เรเดียนซ์ พลัส 15% วิตามิน ซี เซรั่ม 25มล.",
    price: "฿449",
    originalPrice: "฿899",
    image: "https://thmappbkk.blob.core.windows.net/boots/2023/6/28/3dae819f-acd3-493b-9564-3ab1ea2ec1be_large.jpg",
    description: "นัมเบอร์เซเว่น เรเดียนซ์ พลัส 15% วิตามิน ซี เซรั่ม 25 มล. ชาร์จพลังให้สุดกับวิตามินซีเพื่อผิวที่ดูกระจ่างใสและชุ่มชื้นทั้งวัน ด้วยพลังวิตามินซีเข้มข้น 15% ด้วยสูตรทึ่ซึมซาบเข้าสู่ผิวอย่างรวดเร็ว ช่วยฟื้นบำรุงผิวของคุณและช่วยให้ผิวดูกระจ่างใสและเต่งตึงตลอดวัน พร้อมกลิ่นหอมหวานของ อโรม่า ซิตรัส เนื้อเจลสัมผัสเบาบาง ทาง่าย เพื่อผิวที่ฉ่ำวาวและและผิวดูสม่ำเสมอยิ่งขึ้น ปลุกผิวให้สดชื่นในทันที เพื่อเผยผิวดูโกลว์ได้ใน 2 สัปดาห์ ผสานส่วนผสมอันทรงพลังของ วิตามินซีเข้มข้น 15%",
  },
  17: { 
    name: "Anessa Perfect Uv Sunscreen Skincare Milk Na Spf 50+ Pa++++ 60Ml",
    price: "฿659",
    originalPrice: "฿949",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/10/30/f5641db6-9ccf-48d1-a344-1a5e480491c0_large.jpg",
    description:"นัมเบอร์เซเว่น ฟิวเจอร์ รีนิว ดาแมจ โพรเท็คชั่น ดีเฟนซ์ ชีลด์ เอสพีเอฟ 50 / 50 มล. ผลิตภัณฑ์บำรุงผิวหน้าผสมสารป้องกันแสงแดด UVB &UVA SPF50 รังสี UV คือตัวการอันดับ1 ที่ทำร้ายผิว ก่อเกิดปัญหาผิวหลายประการทั้ง ริ้วรอยลึก/ริ้วรอยเล็ก จุดด่างดำ ผิวไม่สม่ำเสมอ ผิวหยานกร้าน ไม่เรียบเนียน นัมเบอร์เซเว่น ฟิวเจอร์ รีนิว ดาแมจ โพรเท็คชั่น ดีเฟนซ์ ชีลด์ พัฒนาขึ้นเพื่อปกป้องปัญหาผิวเสียที่เกิดจากแสงแดดโดยเฉพาะ พร้อมบำรุงด้วย Age-defying peptide technology และ Sodium Hyaluronate เนื้อบางเบา ซึมซาบทันที รู้สึกชุ่มชื่น ผิวดูฉ่ำโกลว์ โดยไม่เหนียวเหนอะหนะเหมาะกับทุกสภาพผิว แม้ผิวบอบบางแพ้ง่าย",
  },
  18: { 
    name: "เมย์เบลลีน นิวยอร์ก รองพื้น ฟิต มี แมท แอนด์ พอร์เลส ฟาวเดชั่น เฉด 228 30 มล.",
    price: "฿319",
    originalPrice: "฿399",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/4/26/0aeffb88-ff66-48bb-aebf-545fb82efc9b_large.jpg",
    description: "เมย์เบลลีน นิวยอร์ก รองพื้น ฟิต มี แมท แอนด์ พอร์เลส ฟาวเดชั่น เฉด 228 30 มล.กำลังมองรองพื้นที่ใช้ มีเฉดสีที่เข้าได้ดีกับผิว ช่วยปกปิดเรียบเนียนอย่างเป็นธรรมชาติยาวนานถึง 12 ชั่วโมง บอกลาปัญหาหน้าเยิ้มระหว่างวัน พร้อมมอบผิวแมทเนียนใส ขอแนะนำเมย์เบลลีน นิวยอร์ก รองพื้น ฟิต มี แมท แอนด์ พอร์เลส ฟาวเดชั่น เฉด 228",
  },
  19: { 
    name: "เบบี้ไบร์ท ชีคโกลว์ซันฟลาวเวอร์บลัช 5.2G 02 บราวน์โรส",
    price: "฿119",
    originalPrice: "฿149",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/1/26/6b27e7de-363e-4b86-9fa6-218c1d104de9_large.jpg",
    description: "เติมเสน่ห์ความสดใสให้พวงแก้มดูสวยระเรื่อ ด้วยเบบี้ ไบร์ท ชีค โกลว์ ซันฟลาวเวอร์ บลัช บลัชออนเนื้อครีม นุ่มละมุน เนียนแนบผิว ติดทน เกลี่ยง่าย ไม่เป็นก้อน อุดมไปด้วยสารสกัดจากน้ำมันเมล็ดทานตะวัน (Helianthus Annuus (Sunflower) Seed Oil) ที่มีกรดไขมันจำเป็น และวิตามินอี (Vitamin E) มีสารแอนตี้ออกซิแดนท์ ช่วยบำรุงผิวให้เรียบเนียน นุ่ม ชุ่มชื้น มอบผลลัพธ์พวงแก้มสวยเปล่งปลั่ง ฉ่ำน้ำ แลดูสุขภาพดีอย่างเป็นธรรมชาติตลอดวัน",
  },
  20: { 
    name: "Anessa Perfect Uv Sunscreen Skincare Milk Na Spf 50+ Pa++++ 60Ml",
    price: "฿119",
    originalPrice: "฿149",
    image: "https://thmappbkk.blob.core.windows.net/boots/2022/12/20/0b67f700-bf53-48d1-a59a-94e321ececcd_large.jpg",
    description: " อเนสซ่าเพอร์เฟค ยูวี ซันสกรีน สกินแคร์ มิลค์ เอ็นเอ เอสพีเอฟ 50+ พีเอ++++กันแดดเนื้อน้ำนม บางเบา ซึมซาบเร็ว สำหรับผิวหน้า ปกป้องผิวจากรังสี UV พร้อมลดเลือนจุดด่างดำ ฝ้าแดด เผยผิวสวย ฉ่ำโกล์ว ชุ่มชื้นยาวนาน 8 ชั่วโมง",
  },
  21: { 
    name: "เบบี้ไบร์ท มูดแมทท์บลัชเชอร์ 4.5g #04 เลิฟ",
    price: "฿149",
    originalPrice: "",
    image: "https://thmappbkk.blob.core.windows.net/boots/2022/12/20/0271ce5c-2132-4cf6-9f2a-90948819624b_large.jpg",
    description: "เติมความสดใสให้พวงแก้มสวยอย่างเป็นธรรมชาติด้วย มูด แมทท์ บลัชเชอร์ บลัชออนเนื้อแมทท์ เนื้อเนียนละเอียด เกลี่ยง่าย ติดทน ช่วยแต่งแต้มสีสันให้พวงแก้มสวยหวาน ดูระเรื่อ โทนสีละมุน ไม่ว่าสีผิวไหนก็ปัดแล้วสวยอย่างเป็นธรรมชาติ กันน้ำ กันเหงื่อ สามารถใช้ทาเป็นอายแชโดว์ได้ พร้อมบำรุงผิวหน้าด้วยวิตามินอี ให้ผิวชุ่มชื้น เปล่งปลั่ง แลดูอ่อนเยาว์ เผยลุคสดใสได้หลากหลายสไตล์",
  },
  22: { 
    name: "Anessa Perfect Uv Sunscreen Skincare Milk Na Spf 50+ Pa++++ 60Ml",
    price: "฿890",
    originalPrice: "",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/10/4/84bf7de2-8ff7-4d3b-b960-bc4175522181_large.jpg",
    description: "คลีนซิ่งบาล์มแบบ All in one เหมาะสำหรับผิวแพ้ง่าย ที่จะมาตอบสนองความต้องการของคุณ ลบออกแม้เครื่องสำอางที่ล้างยาก เป็นทั้งที่ลบเครื่องสำอางและคลีนเซอร์บำรุงผิวในเวลาเดียวกัน ช่วยขจัดสิ่งสกปรกออกจาก อีกทั้งช่วยบำรุงและปรับสมดุลให้ผิวชุ่มชื้น พร้อมปลอบประโลมผิว ส่วนผสมอ่อนโยน",
  },
  23: { 
    name: "เอเวียง โกลว์ เฟเชียล มิสท์ 100 มล.",
    price: "฿599",
    originalPrice: "฿1000",
    image: "https://down-th.img.susercontent.com/file/th-11134201-7r992-m04qtcehfxkq34.webp",
    description: "สเปรย์บำรุงผิวหน้า อุดมสารสกัดจากรากดอกไวท์พีโอนีและสารสกัดใบชาขาวออร์แกนิก อ่อนโยนต่อผิวและช่วยทำให้ผิวฉ่ำโกลว์อย่างเป็นธรรมชาติ ละอองสเปรย์ละเอียดนุ่มช่วยบำรุงผิวและคืนความกระจ่างใส เปล่งประกายให้ผิวชุ่มชื้น แลดูสดใส มีออร่า",
  },
  24: { 
    name: "Anessa Perfect Uv Sunscreen Skincare Milk Na Spf 50+ Pa++++ 60Ml",
    price: "฿427",
    originalPrice: "฿520",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/2/15/f250f1c6-2221-4ea9-83e8-25ee1f2a275c_large.jpg",
    description: "เซรั่มวิตามินซีที่มีกรดแอล-แอสคอร์บิก 10% ที่สามารถเพิ่มความกระจ่างใสและลบเลือนจุดด่างดำและรอยสิว ทำให้ผิวดูเปล่งปลั่งและมีสุขภาพดี อีกทั้งยังมีสารต้านอนุมูลอิสระสามชนิดช่วยป้องกันผิวที่ดูหมองคล้ำ",
  },
  25: { 
    name: "เมย์เบลลีนอายแชโดว์พาเลทท์เดอะบรัชนู้ดส์ 9กรัม",
    price: "฿549",
    originalPrice: "",
    image: "https://thmappbkk.blob.core.windows.net/boots/2024/4/26/3b9eb55c-94e0-4d48-a059-caa8941e2201_large.jpg",
    description: "MAYBELLINE NEW YORK THE BLUSHED NUDES PALETTE 9 g อายแชโดว์พาเลท์ 12 โทนสีโรสโกลด์ที่ออกแบบมาเพื่อสีผิวของชาวเอเชียโดยเฉพาะ สัมผัสความนุ่มละมุนที่จะช่วยแต่งแต้มสีสันให้ลุคสวยของคุณในทุกวัน เหตุผลที่ทำให้คุณหลงรัก สร้างลุคใหม่ได้ไม่จำกัดกับ 12 เฉดสีด้วยหัวแปรงชนิดพิเศษ 2 ด้านที่ช่วยให้การเกลี่ยอายแชโดว์ง่ายขึ้น มาพร้อมเนื้อเนียน เกลี่ยง่าย สีสันติดทนนานตลอดวัน",
  },
};

const recommendedStoreData = {
  name: "ร้านค้าแนะนำ",
  profileImage: "https://i.pinimg.com/564x/54/52/49/545249aba2e5e1ac7edb69084d7309b3.jpg",
  description: "นี่คือร้านค้าแนะนำที่เราขอแนะนำให้คุณดูสินค้าเพิ่มเติม",
};


function ProductBoots() {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData[id];
  const [quantity, setQuantity] = useState(1);
  

  if (!product) {
    return <p>ไม่พบข้อมูลสินค้า</p>;
  }

  const handleIncrement = () => setQuantity(quantity + 1);
  const handleDecrement = () => setQuantity(quantity > 1 ? quantity - 1 : 1);
  const handleAddToCart = () => {
    alert(`เพิ่ม ${product.name} จำนวน ${quantity} ชิ้นลงในตะกร้าแล้ว!`);
  };
  const handleViewRecommendedStore = () => {
    navigate('/recommended-store');
  };

  return (
    <div className="product-detail">
       <div className="header-bar">
        <h3>My Store</h3>
      </div>
      {/* ส่วนแสดงข้อมูลสินค้า */}
      <div className="product-info">
        <div className="product-image">
          <img src={product.image} alt={product.name} style={{ width: '300px' }} />
        </div>
        <div className="product-details">
          <h2>{product.name}</h2>
          <p className="product-price">
            <span className="original-price">{product.originalPrice}</span>
            <span className="discounted-price">{product.price}</span>
          </p>
          <div className="quantity-controls">
            <button onClick={handleDecrement} className="btn btn-secondary">-</button>
            <span>{quantity}</span>
            <button onClick={handleIncrement} className="btn btn-secondary">+</button>
          </div>
          <div className="action-buttons">
            <button onClick={handleAddToCart} className="btn btn-success">Add to Cart</button>
            <button className="btn btn-primary">Buy Now</button>
          </div>
        </div>
      </div>

{/* ส่วนแสดงโปรไฟล์ร้านค้า */}
<div className="recommended-store" style={{ marginBottom: '30px', paddingBottom: '15px', borderBottom: '1px solid #ddd' }}> {/* เพิ่ม marginBottom, paddingBottom และ borderBottom */}
  <h4>ร้านค้าแนะนำ</h4>
  <div 
    className="store-profile" 
    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
  >
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img 
        src={recommendedStoreData.profileImage} 
        alt="Store Profile" 
        style={{ width: '80px', borderRadius: '50%', marginRight: '10px' }}
      />
      <div>
        <h5>{recommendedStoreData.name}</h5>
        <p>{recommendedStoreData.description}</p>
      </div>
    </div>
    <button onClick={handleViewRecommendedStore} className="btn btn-info">ดูร้านค้า</button>
  </div>
</div>


      {/* รายละเอียดสินค้า */}
      <div className="product-description" style={{ marginTop: '30px' }}> {/* เพิ่ม marginTop */}
        <h4>รายละเอียดสินค้า</h4>
        <p>{product.description}</p>
      </div>
    </div>
  );
}


export default ProductBoots;
